import { EffectHandler, EffectType } from "../types/editor"
import StressHandler from "./stress"
import MuteHandler from "./mute"
import globalMuteHandler from "./globalMute"
import MultiToneHandler from "./multi-tone"
import LianduHandler from "./liandu"
import LocalSpeedHandler from "./local-speed"
import MultiSpeaker from "./multi-speaker"
import AliasChange from "./alias-change"
import phoneticsHandler from "./phonetics"

export default function getEffectHandler(type: EffectType): EffectHandler {
    if (type === 'stress') return StressHandler
    if (type === 'mute') return MuteHandler
    if (type === 'multi-tone') return MultiToneHandler
    if (type === 'liandu') return LianduHandler
    if (type === 'localSpeed') return LocalSpeedHandler
    if (type === 'globalMute') return globalMuteHandler
    if (type === 'multiSpeaker') return MultiSpeaker
    if (type === 'aliasChange') return AliasChange
    if (type === 'phonetics')return phoneticsHandler
    return null
}